<app-customer-header></app-customer-header>
<div class="container track-details">
  <div class="row">
    <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12">
      <div class="truck-left">
        <div class="dashboard-menu active">
          <div class="truck-left-icon">
            <img src="assets/img/dashboard.svg" alt="" />
          </div>
          <div class="truck-left-details">
            <h5 (click)="GoToDashboard()">Dashboard</h5>
          </div>
        </div>
        <div class="dashboard-menu">
          <div class="truck-left-icon">
            <img src="assets/img/trip.svg" alt="" />
          </div>
          <div class="truck-left-details" (click)="GoToBookATrips()">
            <h5>Book a Trip</h5>
          </div>
        </div>
        <div class="dashboard-menu">
          <div class="truck-left-icon">
            <img src="assets/img/trips.svg" alt="" />
          </div>
          <div class="truck-left-details">
            <h5 (click)="GoToTrips()">Trips</h5>
          </div>
        </div>
        <div class="dashboard-menu">
          <div class="truck-left-icon">
            <img src="assets/img/help.svg" alt="" />
          </div>
          <div class="truck-left-details">
            <h5 (click)="GoTOHelp()">Help</h5>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-9 col-lg-9 col-md-12 col-sm-12">
      <div [class.spinner]="loading"></div>

      <div class="row">
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12">
          <div class="dashboard-trips">
            <div class="trips">
              <p>Live Trips</p>
            </div>
            <div class="trips-details">
              <p>{{ dashboardArray.liveTrips }}</p>
            </div>
          </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12">
          <div class="dashboard-trips">
            <div class="trips">
              <p>Partially Paid</p>
            </div>
            <div class="trips-details">
              <p>{{ dashboardArray.partiallyPaid }}</p>
            </div>
          </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12">
          <div class="dashboard-trips">
            <div class="trips">
              <p>Trips Expiring Today</p>
            </div>
            <div class="trips-details">
              <p>{{ dashboardArray.tripsExpiry }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
